import { render, staticRenderFns } from "./NotificationPreference.vue?vue&type=template&id=38857b79&"
import script from "./NotificationPreference.vue?vue&type=script&lang=js&"
export * from "./NotificationPreference.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports